var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-wrapper"},[_c('landing-header',{on:{"mobilenav":_vm.catchMobileNav}}),_vm._v(" "),(!_vm.mobileNav)?[_vm._t("default"),_vm._v(" "),_c('logout-footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }